module.exports = __webpack_public_path__ + "img/progress.874d198b.svg";